const firebaseConfig = {
    apiKey: "AIzaSyD_Nvz7OvfphAoBlRqaze4my19AdeB3XRs",
    authDomain: "doctors-portal-2ba18.firebaseapp.com",
    databaseURL: "https://doctors-portal-2ba18.firebaseio.com",
    projectId: "doctors-portal-2ba18",
    storageBucket: "doctors-portal-2ba18.appspot.com",
    messagingSenderId: "874704767375",
    appId: "1:874704767375:web:c752f8df3625213f5f23fa"
  };

  export default firebaseConfig